export default {"src":"/_next/static/image/public/images/ic_notify_me.9f9715df01c43c0382fc96865b6b6454.svg","height":56,"width":56};